import { Button, Grid, IconButton } from '@mui/material'
import { Field, Form, Formik } from 'formik'
import { TextField } from 'formik-material-ui'
import { isEqual } from 'lodash'
import { memo, useCallback, useEffect, useState } from 'react'
import { metodoPrograma } from '../../../components/api'
import Table from '../../../components/Table/Table'
import dayjs from 'dayjs'
import { IoReload } from 'react-icons/io5'
import { MdDelete } from 'react-icons/md'

const retornaLocalAtendimento = (u = []) => ({
  idPLano: u?.[0] || undefined,
  dsPlano: u?.[1] || undefined,
  dtInclusao: u?.[2] || undefined,
  dtExclusao: u?.[3] || undefined,
  vlPlano: u?.[4] || undefined,
})
const Edicao = ({ dados, voltar, setTela, setDadosItem }) => {
  const [itensPlano, setItensPlano] = useState([])

  const getList = useCallback(() => {
    metodoPrograma('listaItensPlano', { idPlano: dados[0] }).then((res) => {
      if (res.status) {
        setItensPlano(res.lista)
      }
    })
  }, [dados])

  const salva = async (values) => {
    const res = await metodoPrograma('salva', values)
    if (res.status) voltar()
  }
  const exclui = (idPlano) => async (e) => {
    e.stopPropagation()
    if (!window.confirm('Mas você tem CERTEZA que deseja excluir???')) return
    await metodoPrograma('excluiItem', { idPlano })
    await getList()
  }

  const handleClick = (_, linha) => {
    setDadosItem(linha)
    setTela('editaItem')
  }

  useEffect(() => {
    if (dados) {
      getList()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getList])
  return (
    <Formik
      initialValues={retornaLocalAtendimento(dados)}
      onSubmit={async (values, { setSubmitting }) => {
        await salva(values)
        setSubmitting(false)
      }}
    >
      {({ isSubmitting, submitForm }) => (
        <Form style={{ width: '100%', padding: 0 }}>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <Field
                component={TextField}
                name="dsPlano"
                label="Nome"
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                component={TextField}
                name="dtInclusao"
                label="Inclusão"
                fullWidth
                margin="dense"
                variant="outlined"
                disabled
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                component={TextField}
                name="dtExclusao"
                label="Exclusão"
                fullWidth
                margin="dense"
                variant="outlined"
                disabled
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                component={TextField}
                name="vlPlano"
                label="Valor"
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <Table
                dados={itensPlano}
                head={[
                  'Serviço',
                  'Quantidade Permitida',
                  'Número dias Referência',
                  'Exclusão',
                  '',
                ]}
                line={(item) => [
                  item[2],
                  item[3],
                  item[4],
                  item[5] ? dayjs(item[5]).format('DD/MM/YYYY HH:MM') : null,
                  '',
                ]}
                columnOptions={[
                  {
                    alias: 4,
                    customJsx: ({ linhaOriginal }) => (
                      <IconButton
                        size="small"
                        onClick={exclui(linhaOriginal[0])}
                      >
                        {linhaOriginal[5] ? <IoReload /> : <MdDelete />}
                      </IconButton>
                    ),
                  },
                ]}
                onClick={handleClick}
              />
            </Grid>
            <Grid
              item
              xs={12}
              style={{ display: 'flex', flexDirection: 'row-reverse' }}
            >
              <Button
                onClick={submitForm}
                disabled={isSubmitting}
                variant="contained"
                color="primary"
                style={{ margin: '5px' }}
              >
                Salvar
              </Button>
              <Button
                onClick={voltar}
                variant="contained"
                color="secondary"
                style={{ margin: '5px' }}
              >
                Cancelar
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}

export default memo(Edicao, isEqual)
